import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function SnoozeTomorrow(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
          <G clipPath="url(#clip0_snoozetomorrow)">
              <Path
                  d="M3.99992 9.33333H11.9999C12.0053 9.33333 12.0099 9.334 12.0133 9.33333C12.3819 9.33333 12.6799 9.03467 12.6799 8.66667C12.6799 8.61733 12.6746 8.56933 12.6653 8.52333C12.5886 6.016 10.5253 4 7.99992 4C5.42725 4 3.33325 6.09333 3.33325 8.66667C3.33325 9.03467 3.63125 9.33333 3.99992 9.33333Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M15.3333 10.6667H0.666667C0.298 10.6667 0 10.9653 0 11.3333C0 11.7013 0.298 12 0.666667 12H15.3333C15.702 12 16 11.7013 16 11.3333C16 10.9653 15.702 10.6667 15.3333 10.6667Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M13.3333 13.3333H2.66667C2.298 13.3333 2 13.632 2 14C2 14.368 2.298 14.6667 2.66667 14.6667H13.3333C13.702 14.6667 14 14.368 14 14C14 13.632 13.702 13.3333 13.3333 13.3333Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M8.66659 0.666672H7.33325V2.66667H8.66659V0.666672Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M14.1286 3.48108L13.1858 2.53828L11.7716 3.95248L12.7144 4.89528L14.1286 3.48108Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M16 9.33333L16 8L14 8L14 9.33333L16 9.33333Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M3.2862 4.89544L4.229 3.95264L2.8148 2.53844L1.872 3.48124L3.2862 4.89544Z"
                  fill={AppTheme.almostBlack}
              />
              <Path
                  d="M2 9.33333L2 8H0L0 9.33333H2Z"
                  fill={AppTheme.almostBlack}
              />
          </G>
          <Defs>
              <ClipPath id="clip0_snoozetomorrow">
                  <Rect width="16" height="16" fill="white"/>
              </ClipPath>
          </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
